"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var window_or_global_1 = __importDefault(require("window-or-global"));
var defaultLocale = 'en-US';
exports.setLocale = function (newLocale) {
    if (!newLocale)
        return;
    window_or_global_1.default.__epic_common_locale = newLocale;
};
exports.getLocale = function () {
    return window_or_global_1.default.__epic_common_locale || defaultLocale;
};
exports.getOgLocale = function () {
    var locale = exports.getLocale();
    if (locale.indexOf('-') !== -1) {
        locale = locale.replace('-', '_');
    }
    return locale;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2xvY2FsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNFQUFvQztBQUVwQyxJQUFNLGFBQWEsR0FBRyxPQUFPLENBQUM7QUFFakIsUUFBQSxTQUFTLEdBQUcsVUFBQyxTQUFpQjtJQUN2QyxJQUFJLENBQUMsU0FBUztRQUFFLE9BQU87SUFDdkIsMEJBQUksQ0FBQyxvQkFBb0IsR0FBRyxTQUFTLENBQUM7QUFDMUMsQ0FBQyxDQUFDO0FBRVcsUUFBQSxTQUFTLEdBQUc7SUFDckIsT0FBTywwQkFBSSxDQUFDLG9CQUFvQixJQUFJLGFBQWEsQ0FBQztBQUN0RCxDQUFDLENBQUM7QUFFVyxRQUFBLFdBQVcsR0FBRztJQUN2QixJQUFJLE1BQU0sR0FBRyxpQkFBUyxFQUFFLENBQUM7SUFDekIsSUFBSSxNQUFNLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFO1FBQzVCLE1BQU0sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxHQUFHLENBQUMsQ0FBQztLQUNyQztJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2xCLENBQUMsQ0FBQyJ9